"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetApiCacheKey = void 0;
var router_1 = require("next/router");
var provider_1 = require("../../provider");
function useGetApiCacheKey() {
    var baseUrl = provider_1.useCoverageApiBasePath();
    var router = router_1.useRouter();
    var appBasePath = (router === null || router === void 0 ? void 0 : router.basePath) || '';
    return function (url) { return "" + appBasePath + baseUrl + url; };
}
exports.useGetApiCacheKey = useGetApiCacheKey;
